"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableBodyOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape;
    return ({
        root: {
            backgroundColor: palette.secondary.main,
            borderRadius: shape.borderRadius,
        },
    });
};
//# sourceMappingURL=MuiTableBody.js.map